import { reduce, map, toNumber } from 'lodash';

import Model from 'models';
import StorefrontCartLineItemModel from 'models/StorefrontCartLineItem';
import Money, { PRICE_FORMAT } from 'utils/Money';

const StorefrontCartModel = class extends Model {
  get id() {
    return 0;
  }

  get cartLines() {
    return this._data?.lines?.edges;
  }

  get cost() {
    return this._data?.cost;
  }

  get subtotal() {
    return this.cost?.subtotalAmount?.amount;
  }

  get subtotalCurrencyCode() {
    return this.cost?.subtotalAmount?.currencyCode;
  }

  get cleanedSubtotal() {
    return Math.floor(toNumber(this.subtotal) * 100);
  }

  get checkoutUrl() {
    return this._data?.checkoutUrl;
  }

  get attributes() {
    if (!this._data?.attributes) return null;
    const attributes = this._data?.attributes;
    const massagedAttributes = attributes.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: item.value }),
      {}
    );

    return massagedAttributes;
  }

  get items() {
    const unsortedLineItems = map(
      this.cartLines,
      cartLine => new StorefrontCartLineItemModel(cartLine)
    );

    return unsortedLineItems;
  }

  get giftMessage() {
    return this.attributes?.gift_message;
  }

  get useLogoFreePackaging() {
    // attributes are set as strings due to being query params. This is easy way to convert
    return this.attributes?.logo_free === 'true';
  }

  // We must snake_case the following fields to match what the Ajax API spits out
  get total_price_with_currency() {
    if (!this.cleanedSubtotal) return null;

    const transformedSubtotal = new Money(this.cleanedSubtotal, this.subtotalCurrencyCode);
    const formattedSubUnits = transformedSubtotal.format(PRICE_FORMAT.unitsAndSubUnits);
    const formattedUnits = transformedSubtotal.format();

    let formattedPrice = formattedUnits;
    if (!Number.isInteger(transformedSubtotal.subUnits / 100)) {
      formattedPrice = formattedSubUnits;
    }

    return `${formattedPrice}`;
  }

  get total_price() {
    return this.cleanedSubtotal;
  }

  get item_count() {
    return reduce(
      this.cartLines,
      (acc, { node }) => {
        const lineItemQuantity = node.quantity || 0;
        // eslint-disable-next-line no-param-reassign
        acc += lineItemQuantity;
        return acc;
      },
      0
    );
  }
};

export default StorefrontCartModel;
